import React from "react";

import { Text } from "@bookingcom/bui-react";
import { useI18n, I18nChildContext } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";

import useGlobalContext from "../hooks/useGlobalContext";
import styles from "./NoJS.module.css";

export default function NoJS() {
  const i18n = useI18n() as I18nChildContext;
  const { env, userAgent } = useGlobalContext();

  return env === "prod" && !userAgent.isBot ? (
    <noscript className={styles.root}>
      <Text variant="headline_3">{i18n.trans(t("flights_error_js_header"))}</Text>
      <Text variant="featured_2">{i18n.trans(t("flights_error_js_sub"))}</Text>
    </noscript>
  ) : (
    <></>
  );
}
